// A typed board in the canvas's place: its own surface, and its own island where the rail sits. Around it
// everything stays as on a canvas (App.tsx): the scene, the board pill, the chat, Connect, the Data panel,
// toasts, All boards and the theme strip.

import { Suspense } from "react";
import { BOARD_KINDS, kindOf } from "../../shared/boardKinds";
import type { Board } from "../../shared/types";
import { Recover } from "../chrome/Recover";
import { KINDS } from "./kinds";

export function Shell({ board }: { board: Board }) {
  const kind = kindOf(board);
  const view = KINDS[kind];
  return (
    <div className="shell" data-kind={kind}>
      <Recover key={board.id}>
        {view ? (
          <Suspense fallback={null}>
            <view.View board={board} />
          </Suspense>
        ) : (
          <NotHere board={board} />
        )}
      </Recover>
    </div>
  );
}

/** A board of a kind this version cannot draw yet: said plainly, and nothing on it is touched. */
export function NotHere({ board }: { board: Board }) {
  return (
    <section className="shell-surface shell-not-here">
      <p>
        “{board.name}” is a {BOARD_KINDS[kindOf(board)].name.toLowerCase()} board, which this version of Context Board cannot show yet. Nothing on it has changed.
      </p>
    </section>
  );
}
